// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Fechamentos_CalcularLucroResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for /fechamentos/calcular_lucro
 *
 * POST /fechamentos/calcular_lucro/{id}
 *
 * Returns calculated monthly profit for a fechamento
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Fechamentos_CalcularLucroResponseDados {
id: number
lucro_mensal: number
faturamento: number
despesas: number
folha_pagamento: number
impostos: number
taxas: number
}

export type Fechamentos_CalcularLucroResponse = ApiResponse<Fechamentos_CalcularLucroResponseDados>;

registerResponseContract('Fechamentos_CalcularLucroResponse', {
  id:              { type: 'number',  required: true },
  lucro_mensal:    { type: 'number',  required: true },
  faturamento:     { type: 'number',  required: true },
  despesas:        { type: 'number',  required: true },
  folha_pagamento: { type: 'number',  required: true },
  impostos:        { type: 'number',  required: true },
  taxas:           { type: 'number',  required: true },
})
